import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './components/App';
import './index.css';

// ❌ OFFLINE çalışma iptal ediliyor
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// ✅ Servis worker kapalı — offline yok
serviceWorkerRegistration.unregister();
